<template lang="pug">
	.audio-tracker-ruler
		.rule-holder(:class="[getVH('flex-row', 'flex-col'), orientation, reverse ? 'reverse' : '']")
			template(v-for="elems in [getElements()]")
				.tick(v-for="(elem, idx) in elems", :class="{ number: elem.showNumber, stick: !(idx % showEvery), 'no-tick': !tickVisible, horizontal: orientation === 'horizontal', vertical: orientation === 'vertical' }", :style="getStyle(idx, elems)")
					.number-value(v-if="elem.showNumber", :class="{ 'is-last': (reverse ? idx === 0 : idx === elems.length-1) && isFixedWidth }", :style="{ '--fontSize': fontSize || '10px' }") {{elem.number}}
			slot(name="default")
</template>

<script>
	import $ from 'jquery';
	import VueTypes from 'vue-types';

	export default {
		translationCategory: 'audioTracker.AudioTrackerRuler',
		name: 'audio-tracker-ruler',
		props:  {
			width: VueTypes.any.def(null),
			totalTime: VueTypes.number.def(0),
			pixelsPerSecond: VueTypes.any.def(null),
			valueHandler: VueTypes.any.def(null),
			isTime: VueTypes.bool.def(true),
			step: VueTypes.number.def(8),
			specifiedTickInterval: VueTypes.number.def(null),
			isFixedWidth: VueTypes.bool.def(false),
			orientation: VueTypes.oneOf(['vertical', 'horizontal']).def('horizontal'),
			reverse: VueTypes.bool.def(false),
			fontSize: VueTypes.any.def(null),
			tickVisible: VueTypes.bool.def(true)
		},
		computed: {
			tickInterval() {
				return this.specifiedTickInterval || Math.max(parseInt(this.widthSeconds() / this.step), 1);
			},
			showEvery() {
				return Math.max(1, parseInt(this.getElements().length / 80));
			}
		},
		mounted() {
			setImmediate(() => {
				if (this._isDestroyed) return;
				this.$forceUpdate();
			});
		},
		methods: {
			getStyle(idx, elems) {
				var style = {};
				var size = idx === elems.length-1 && this.isFixedWidth ? 0 : this.tickInterval * this.pixelsPerSecondValue();

				style = this.getVH(
				{
					'min-width': `${size}px`,
					'max-width': size > 0 ? `${size}px` : null
				},
				{
					'min-height': `${size}px`,
					'max-height': `${size}px`
				});

				return style;
			},
			getVH(horValue, vertValue) {
				return this.orientation === 'vertical' ? vertValue : horValue;
			},
			pixelsPerSecondValue() {
				return (typeof(this.pixelsPerSecond) === 'function' ? this.pixelsPerSecond() : this.pixelsPerSecond) || 0;
			},
			widthSeconds() {
				return (typeof(this.width) === 'function' ? this.width() : $(this.$el).width()) / this.pixelsPerSecondValue();
			},
			getElements() {
				var elems = [];
				var num = 0;
				var total = this.isTime ? ((parseInt(Math.max(this.totalTime, this.widthSeconds())) + 1) || 0) : this.totalTime;
				for (var i = 0; i < total; i += this.tickInterval) {
					var value = {
						showNumber: true,
						number: `${Math.floor(i / 60)}:${`0${num}`.substr(-2)}`
					};
					if (this.valueHandler) {
						var val = this.valueHandler({ i, value, tickInterval: this.tickInterval, total, num });
						if (val) value = val;
						if (val === false)
							break;
					}
					elems.push(value);

					num += this.tickInterval;
					if (this.isTime) {
						while (num >= 60)
							num = num - 60;
					}
				};
				return elems;
			}
		}
	};
</script>
<style lang='scss'>
	.audio-tracker-ruler {

		&.horizontal {
			height: 15px;
		}

		&.vertical {
			width: 15px;
		}

		user-select: none;

		.rule-holder {
			overflow: hidden;

			&.horizontal {
				height: 15px;
				width: 100%;
			}

			&.vertical {
				width: 15px;
				height: 100%;
			}

			.tick {

				&.number {
					&.horizontal:not(.no-tick) {
						border-left: 1px solid #bfbfbf;
					}

					&.vertical:not(.no-tick) {
						border-top: 1px solid #bfbfbf;
					}

					> .number-value {
						margin-top: -2px;
						margin-left: 0.7px;
						font-size: var(--fontSize);
						color: #00000085;
					}
				}

				&.horizontal {
					height: 100%;
					margin-top: 11px;

					&.number {
						margin-top: 2px;

						> .number-value {
							&.is-last {
								margin-left: -6px;
							}
						}
					}
				}

				&.vertical {
					width: 100%;
					margin-left: 11px;

					&.number {
						margin-left: 0px;

						> .number-value {
							&.is-last {
								margin-top: -7px;
							}
						}
					}
				}

				&.stick {

					&.horizontal:not(.no-tick) {
						border-left: 1px solid #cccccc;
					}

					&.vertical:not(.no-tick) {
						border-top: 1px solid #cccccc;
					}

					&:not(.number) {
						&.horizontal {
							height: 40%;
						}

						&.vertical {
							width: 40%;
						}
					}
				}
			}
		}
	}
</style>
